import React from 'react'
import PreviousSSD from '../../sanityInterfaces/PreviousSSD';

interface contentProps {
    data: PreviousSSD;
}

const SpecialSessionsContent = (props: contentProps) => {
    return (
        <div className="p-4 my-4 grid gap-5 text-left space-y-2">
            {props?.data?.SpecialSession && props?.data.SpecialSession?.map((item, index) => {
                return (
                    <div key={index}>
                        <h1 className='text-red-500 text-3xl font-semibold'>{item?.SpecialSessionTitle}</h1>
                        <div className='border grid rounded-lg border-stale-200 p-4 mx-6'>
                            {item?.SpecialSessionDescription?.length > 0 && item?.SpecialSessionDescription?.map((e, i) => {
                                return (
                                    <div className='flex space-x-8' key={i}>
                                        {i === item?.SpecialSessionDescription?.length - 1 ? 
                                            <p className='my-4'>{e?.children[0]?.text}</p>
                                        : 
                                            <>
                                                {i === 0 ? 
                                                    <p className='text-xl font-semibold text-red-500'>{e?.children[0]?.text}</p>
                                                : 
                                                    <p>{e?.children[0]?.text}</p>
                                                }
                                                {e?.children?.length > 1 && 
                                                    <p className='font-semibold text-cyan-500'>{e?.children[1]?.text}</p>
                                                }
                                            </>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default SpecialSessionsContent